import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss']
})
export class CheckBoxComponent {
  @Input() options: { value: string; label: string }[] = [];
  @Input() selectedValues: string[] = [];
  @Output() selectionChanged = new EventEmitter<string[]>();

  toggleCheckbox(value: string) {
    if (this.selectedValues.includes(value)) {
      this.selectedValues = this.selectedValues.filter((v) => v !== value);
    } else {
      this.selectedValues.push(value);
    }
    this.selectionChanged.emit(this.selectedValues);
  }
}
